// src/components/ClientLogosCarousel.js
import React from 'react';
import Slider from 'react-slick';
import './ClientLogosCarousel.css';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css'; 

const logos = [
  { id: 1, src: '/img/client1.png', alt: 'Cliente 1' },
  { id: 2, src: '/img/client2.png', alt: 'Cliente 2' },
];

function ClientLogosCarousel() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000, // Reducido para mejor rendimiento en móviles
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000, // Evita desplazamiento continuo
    cssEase: 'linear',
    pauseOnHover: true, // Mejor experiencia en pantallas táctiles
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="client-logos-carousel">
      <h2 className="section-title">Nuestros Clientes</h2>
      <Slider {...settings}>
        {[...logos, ...logos].map((logo) => (
          <div key={logo.id} className="logo-slide">
            <img src={logo.src} alt={logo.alt} className="client-logo" />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default ClientLogosCarousel;

